const echarts = require('echarts');
module.exports = {
  //饼图封装
  pieOption(params){
    return {
      title: [
        {
          text: params.name,
          left: '46%',
          top: '86%',
          textAlign: 'center',
          textStyle: {
            fontWeight: 'normal',
            fontSize: '16',
            color: '#fff',
            textAlign: 'center',
          },
        }
      ],
      series: [
        {
          type: 'pie',
          hoverAnimation: false,
          radius: ['50%', '66%'],
          data: [{
            value: params.value,
            label: {
              position: 'center',
              color: '#60acfc',
              formatter: '{c}%',
              fontSize: 20
            },
            itemStyle: {
              color: '#60acfc'
            }
          }, {
            value: 100-params.value,
            tooltip: {
              show: false
            },
            label: {
              position: 'center',
              color: 'rgba(0,0,0,0)',
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              color: '#B3B3B3'
            },
            emphasis: {
              itemStyle: {
                color: '#B3B3B3'
              }
            }
          }]
        }
      ],
    };
  },
  //订单柱状图
  pillarData(orderNum, orderPeopleNum, xData){
    return{
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c}"
      },
      legend: {
        icon: 'circle',
        itemWidth:12,
        itemHeight:12,
        left: 'left',
        textStyle: {
          color: '#9FBFE0',
          fontSize: '14px',
        },
        data: [
          '订单数',
          '订单人数',
        ]
      },
      xAxis: {
        type: 'category',
        axisTick: false,
        data: xData,
        axisLine: {
          lineStyle: {
            color: 'rgba(77,176,244,.2)',
          },
        },
        axisLabel:{
          textStyle: {
            color: '#9FBFE0',
            fontSize: 14
          },
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false
        },
        axisLabel:{
          textStyle: {
            color: '#9FBFE0',
            fontSize: 12
          },
        },
        splitLine: {
          lineStyle: {
            color: ['rgba(77,176,244,.2)']
          }
        }
      },
      series: [
        {
          name: '订单数',
          data: orderNum,
          type: 'bar',
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#5ECBE7'
          }, {
            offset: 1,
            color: '#3372BB'
          }]),
          showBackground: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top', //在上方显示
                textStyle: { //数值样式
                  color: '#9FBFE0',
                  fontSize: 12
                }
              }
            }
          }
        },
        {
          name: '订单人数',
          data: orderPeopleNum,
          type: 'bar',
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#90E8C4'
          }, {
            offset: 1,
            color: '#5FB69E'
          }]),
          showBackground: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top', //在上方显示
                textStyle: { //数值样式
                  color: '#9FBFE0',
                  fontSize: 12
                }
              }
            }
          }
        },
      ]
    };
  },
  productMap(legendData,seriesData){
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        icon: 'circle',
        orient: 'vertical',
        left: 'left',
        top: 'middle',
        textStyle: {
          color: '#3B8CF1',
          fontSize: '14px',
        },
        data: legendData,
      },
      series: [
        {
          name: '访问来源',
          type: 'pie',
          center: ['50%', '50%'],
          radius: ["45%", "70%"],
          color: ['#756CEC','#F66555','#FFBD3B','#6BB5EC'],
          data: seriesData,
          itemStyle: {
            borderWidth: 3,
            borderColor: "#1F274C",
          }
        }
      ]
    }
  },
  //订单柱状图
  salePillarData(colors, xData){
    return  {
      xAxis: {
        type: 'category',
        axisTick: false,
        data: xData,
        axisLine: {
          lineStyle: {
            color: 'rgba(77,176,244,.2)',
          },
        },
        axisLabel:{
          textStyle: {
            color: '#9FBFE0',
            fontSize: 14
          },
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false
        },
        axisLabel:{
          textStyle: {
            color: '#9FBFE0',
            fontSize: 12
          },
        },
        splitLine: {
          lineStyle: {
            color: ['rgba(77,176,244,.2)']
          }
        }
      },
      series: [
        {
          name: '订单数',
          barWidth: 30,
          data: [
            {
              value: 20,
              itemStyle: {
                normal: {
                  color: colors[0],
                  label: {
                    show: true,
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: '#9FBFE0',
                      fontSize: 12
                    }
                  }
                }
              }
            },
            {
              value: 80,
              barWidth: 30,
              itemStyle: {
                normal: {
                  color: colors[1],
                  label: {
                    show: true,
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: '#9FBFE0',
                      fontSize: 12
                    }
                  }
                }
              }
            },
            {
              value: 220,
              barWidth: 30,
              itemStyle: {
                normal: {
                  color: colors[2],
                  label: {
                    show: true,
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: '#9FBFE0',
                      fontSize: 12
                    }
                  }
                }
              }
            },
            {
              value: 170,
              barWidth: 30,
              itemStyle: {
                normal: {
                  color: colors[3],
                  label: {
                    show: true,
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: '#9FBFE0',
                      fontSize: 12
                    }
                  }
                }
              }
            },
          ],
          type: 'bar',
          color: colors,
          showBackground: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top', //在上方显示
                textStyle: { //数值样式
                  color: '#9FBFE0',
                  fontSize: 12
                }
              }
            }
          }
        },
      ]
    };
  },
}



// WEBPACK FOOTER //
// ./src/components/echart/systemDataDisplay.js